import React from 'react';

interface FilterSectionProps {
  businessUnits: string[];
  regions: string[];
  selectedBUs: string[];
  selectedRegions: string[];
  onBUChange: (selected: string[]) => void;
  onRegionChange: (selected: string[]) => void;
  onClearAll: () => void;
}

const FilterSection: React.FC<FilterSectionProps> = ({
  businessUnits,
  regions,
  selectedBUs,
  selectedRegions,
  onBUChange,
  onRegionChange,
  onClearAll
}) => {
  const handleBUToggle = (bu: string) => {
    if (selectedBUs.includes(bu)) {
      onBUChange(selectedBUs.filter(item => item !== bu));
    } else {
      onBUChange([...selectedBUs, bu]);
    }
  };

  const handleRegionToggle = (region: string) => {
    if (selectedRegions.includes(region)) {
      onRegionChange(selectedRegions.filter(item => item !== region));
    } else {
      onRegionChange([...selectedRegions, region]);
    }
  };

  const handleSelectAllBUs = () => {
    if (selectedBUs.length === businessUnits.length) {
      onBUChange([]);
    } else {
      onBUChange(businessUnits);
    }
  };

  const handleSelectAllRegions = () => {
    if (selectedRegions.length === regions.length) {
      onRegionChange([]);
    } else {
      onRegionChange(regions);
    }
  };

  const hasActiveFilters = selectedBUs.length > 0 || selectedRegions.length > 0;

  return (
    <div className="filter-section">
      {hasActiveFilters && (
        <div className="clear-filters-row">
          <button className="clear-all-btn" onClick={onClearAll}>
            Clear All Filters
          </button>
        </div>
      )}
      <div className="filter-row">
        <button
          className={`select-all-btn ${selectedBUs.length === businessUnits.length ? 'active' : ''}`}
          onClick={handleSelectAllBUs}
        >
          Select All
        </button>
        {businessUnits.map(bu => (
          <button
            key={bu}
            className={`filter-btn ${selectedBUs.includes(bu) ? 'active' : ''}`}
            onClick={() => handleBUToggle(bu)}
          >
            {bu}
          </button>
        ))}
      </div>
      
      <div className="filter-row">
        <button
          className={`select-all-btn ${selectedRegions.length === regions.length ? 'active' : ''}`}
          onClick={handleSelectAllRegions}
        >
          Select All
        </button>
        {regions.map(region => (
          <button
            key={region}
            className={`filter-btn ${selectedRegions.includes(region) ? 'active' : ''}`}
            onClick={() => handleRegionToggle(region)}
          >
            {region}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FilterSection;